
const store =  require('@os-store/booking/cart');

store.mutations = {
  ...store.mutations,
  pushOutMenuPros (state, pros) {
    state.outMenuProducts.push(...pros)
  },
  clearOutMenuPros (state) {
    state.outMenuProducts = [];
  },
  updateOutMenuPros (state, pros) {
    state.outMenuProducts = [];
    state.outMenuProducts.push(...pros)
  },
  updateGiveProducts(state, giveProducts) {
    console.log('赠品更新..................',giveProducts);
    state.giveProducts.push(...giveProducts);
  },
};
export default store



// WEBPACK FOOTER //
// ./store/booking/cart.js